import { gql } from 'apollo-boost';

import { ValidationErrorFragment, ValidationWarningFragment } from './common';

export const updatePricePackages = gql`
    mutation UpdatePricePackages($input: GdUpdatePricePackagesInput!) {
        reqId: getReqId
        updatePricePackages(input: $input) {
            updatedItems {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;

export const addPricePackage = gql`
    mutation AddPricePackage($input: GdAddPricePackagesInput!) {
        reqId: getReqId
        addPricePackages(input: $input) {
            addedItems {
                id
            }
            validationResult {
                errors {
                    ...ValidationErrorFragment
                }
                warnings {
                    ...ValidationWarningFragment
                }
            }
        }
    }
    ${ValidationErrorFragment}
    ${ValidationWarningFragment}
`;
